import { Component, OnChanges, AfterViewInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { GridFetchModel } from './../../models/grid/grid-fetch.model';
import { GridService } from './shared';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-browse',
  providers: [GridService],
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],

})


export class GridComponent {

  gridOptions: GridOptionsModel;


  columnDefinitions: Array<ColumnDefinitionsModel> = [
    { caption: 'User', field: 'user', type: 'LINK', sortDirection: 'Desc', enableSorting: true, enableFilter: true, cssClass: '', priority: 7 },
    { caption: 'Email', field: 'email', type: 'TEXT', sortDirection: 'Asc', enableSorting: false, enableFilter: false, cssClass: '', priority: 6 },
    { caption: 'Action', field: 'action', type: 'HYPERLINK', sortDirection: 'Asc', enableSorting: false, enableFilter: false, cssClass: '', priority: 3 },
    { caption: 'Checkbox', field: 'col1', type: 'CHECKBOX', sortDirection: 'Asc', enableSorting: false, enableFilter: false, cssClass: '', priority: 2 },
    { caption: 'Radio', field: 'col2', type: 'RADIO', sortDirection: 'Asc', enableSorting: false, enableFilter: false, cssClass: '', priority: 1 }
  ];

//  { "ctnNumber": "4392382781", "userName": "John Smiths", "model": "iphone5", "imei": "4234568690", "status": "ENROLLED_ACTIVE" } 
   
  Paginations: PaginationsModel = {
    recordsPerPage: 20,
    currentPage: 1,
    isServerSide: true,
    totalRecords: 10000
  };




  constructor(private router: Router,
    private gridService: GridService,
    private utilityService: UtilityService,
    private http: HttpClient) {
    console.log('app constructor');
    this.getData();
    console.log(this.gridOptions);

  }

  getData() {

    console.log('Service getData');

    this.gridService.fetchGridData('http://localhost:4200/businessconsole/assets/mock/griddata-full.json').
    // this.gridService.fetchGridData('http://localhost:4200/businessconsole/assets/mock/mock-griddata-page.json').
      subscribe(respobj => {
        console.log(respobj);

        const options = new GridOptionsModel();

        const gridFetch: GridFetchModel = new GridFetchModel();
        gridFetch.class = 'API::CompanyEmployeeTextCriteria';
        gridFetch.withSubscriptions = [
          '173B46D3-D2F3-412B-8405-89D491378BEF',
          '121212122-D2F3-412B-8405-89D491378BEF'
        ];

        options.enableFiltering = true;
        options.enableSorting = true;
        options.gridData = respobj;
        options.columnDefinitions = this.columnDefinitions;
        options.Paginations = this.Paginations;
        // options.gridFetch = gridFetch;
        // options.dataUrl = this.utilityService.getEnvConfig().mockGridDataUrl;
{}
        // this.gridOptions = options;
        this.gridOptions = respobj;

      }, error => {
        this.handleError(error);
      });
  }

  linkActivated(data) {
    console.log('grid page link');
    console.log(data);

    /*if (!!data.selectedColumn && data.selectedColumn == 'user') {
      this.router.navigate(['userSummary/' + data.id]);
    } */

    return false;
  }


  checkboxSelections(data) {
    console.log('checkboxSelections');
    console.log(data);
  }

  radioSelections(data) {
    console.log('radioSelections');
    console.log(data);
  }
  handleError(error) {
    console.log(error);
  }
}
